import EventList from './EventList';
import EventEdit from './EventEdit';
import Icon from '@material-ui/icons/LocalPlay';

export const EventIcon = Icon;

export default {
    list: EventList,
    edit: EventEdit,
}